module.exports = __webpack_public_path__ + "static/media/blankState.728a1aa7.svg";